import React from 'react';
import { useDroppable, useDndContext } from '@dnd-kit/core';
import DraggableTire from './DraggableTire';

const Shop = ({ initialData }) => {
    const { active } = useDndContext();
    const { setNodeRef, isOver } = useDroppable({
        id: 'shop',
        data: {
            type: 'section',
            sectionType: 'shop'
        }
    });

    const allTires = initialData?.map(tire => ({
        id: `shop-tire-${tire.tireId}`,
        label: 'Shop Tire',
        tire: tire,
        sectionType: 'shop'
    })) || [];

    // Filter out the currently dragged tire if it's from this shop
    const visibleTires = allTires.filter(position => {
        // If there's no active drag, show all tires
        if (!active) return true;
        
        // If the active drag is from this shop, hide that specific tire
        return position.id !== active.id;
    });

    return (
        <div 
            ref={setNodeRef}
            className={`w-full flex flex-col gap-4 p-4 h-full max-h-[600px] overflow-hidden overflow-y-auto ${
                isOver ? 'bg-gray-200' : ''
            }`}
        >
            {visibleTires.length > 0 ? (
                <div className="grid grid-cols-1 gap-3">
                    {visibleTires.map((position) => (
                        <DraggableTire
                            key={position.id}
                            tire={position.tire}
                            position={position}
                        />
                    ))}
                </div>
            ) : (
                <div className="flex items-center justify-center h-full text-gray-400 text-sm">
                    {allTires.length > 0 ? 'Drag in progress...' : 'No tires found.'}
                </div>
            )}
        </div>
    );
};

export default Shop;